/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Destination secrets (only included when includeSecrets is true)
 * @export
 * @interface DestinationWithSecretsSecrets
 */
export interface DestinationWithSecretsSecrets {
    /**
     * Webhook signing key for the destination (only included for webhook destinations)
     * @type {string}
     * @memberof DestinationWithSecretsSecrets
     */
    webhookSigningKey?: string;
}

/**
 * Check if a given object implements the DestinationWithSecretsSecrets interface.
 */
export function instanceOfDestinationWithSecretsSecrets(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DestinationWithSecretsSecretsFromJSON(json: any): DestinationWithSecretsSecrets {
    return DestinationWithSecretsSecretsFromJSONTyped(json, false);
}

export function DestinationWithSecretsSecretsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DestinationWithSecretsSecrets {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'webhookSigningKey': !exists(json, 'webhookSigningKey') ? undefined : json['webhookSigningKey'],
    };
}

export function DestinationWithSecretsSecretsToJSON(value?: DestinationWithSecretsSecrets | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'webhookSigningKey': value.webhookSigningKey,
    };
}

